import Vue from 'vue'

/**
 * Directive for triggering outside click of an element
 */
Vue.directive('custom-click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            //TSM 02.11.2023 - Added trigger-button id check to avoid triggering the click outside event on the button which opens the dialog
            if (event.target.id !== 'trigger-button' && !(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});